import { render, staticRenderFns } from "./CouponsCard.vue?vue&type=template&id=dcff4508&scoped=true&"
import script from "./CouponsCard.vue?vue&type=script&lang=js&"
export * from "./CouponsCard.vue?vue&type=script&lang=js&"
import style0 from "./CouponsCard.vue?vue&type=style&index=0&id=dcff4508&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcff4508",
  null
  
)

export default component.exports